/** Bounded fulfilled cache; active callers keep ownership of their result. */
export function createDemandCache(load, { maxBytes = 32 * 1024 * 1024, maxEntries = 12, sizeOf = (value) => new TextEncoder().encode(JSON.stringify(value)).length } = {}) {
  const entries = new Map();
  let retainedBytes = 0;
  function trim() {
    for (const [key, entry] of entries) {
      if (retainedBytes <= maxBytes && entries.size <= maxEntries) break;
      if (!entry.ready) continue;
      retainedBytes -= entry.bytes; entries.delete(key);
    }
  }
  return {
    read(key) {
      const existing = entries.get(key);
      if (existing) { entries.delete(key); entries.set(key, existing); return existing.promise; }
      const entry = { ready: false, bytes: 0 };
      entry.promise = Promise.resolve().then(() => load(key)).then((value) => {
        entry.ready = true; entry.bytes = sizeOf(value, key); retainedBytes += entry.bytes; trim(); return value;
      }, (error) => { if (entries.get(key) === entry) entries.delete(key); throw error; });
      entries.set(key, entry); trim(); return entry.promise;
    },
    stats: () => ({ entries: entries.size, retainedBytes, maxBytes, maxEntries }),
  };
}
